import { ReactNode, FC } from 'react';

export const MAX_MULTISHOW = 3;

interface PerformProps {
    name: string;
    text: ReactNode;
}

export const Perform: FC<PerformProps> = ({ name, text }) =>
    !text ? null : (
        <div>
            <b>{name}:</b> {text}
        </div>
    );
